import React, { Component } from 'react'
import { FormGroup, FormControl, ControlLabel, Row, Col } from 'react-bootstrap'

import i18next from 'i18next'
import validator from 'validator'
import Button from './Button'
import LanguageSelectorFormControl from './LanguageSelectorFormControl'

import invitationStyles from './styles/invitation.scss'

export default class Wopi360InvitationForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      language: 'fi', // Only Finnish for now // props.wopi360TargetDetails.language,
      manager: '',
      recipients: '',
      message: '',
      emailDisclaimer: false,
      isManagerInputDisabled: false,

      form: {
        isValid: false,
        invalidEmails: []
      }
    }
  }

  componentDidMount() {
    this.setState({ isManagerInputDisabled: this.checkDisableManagerInput(this.props) })
  }

  componentWillReceiveProps(props) {
    this.setState({ isManagerInputDisabled: this.checkDisableManagerInput(props) })
  }

  render() {
    const { wopi360TargetDetails } = this.props

    return (
      <div>
        <Row>
          <Col md={6}>
            <LanguageSelectorFormControl
              onChange={this.handleChange}
              defaultValue={this.state.language}
              isDisabled={true /*wopi360TargetDetails.closedAt*/}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup
              controlId="manager"
              validationState={this.state.form.invalidEmails.length > 0 ? 'error' : null}
              style={{ marginBottom: '5px' }}
            >
              <ControlLabel>
                {i18next.t('recipients')}

                {this.state.form.invalidEmails.length > 0 && (
                  <div className={invitationStyles.invalidEmails}>
                    <p>{i18next.t('check_invalid_emails')}</p>

                    {this.state.form.invalidEmails.map((e, key) => <span key={key}>{e}</span>)}
                  </div>
                )}
              </ControlLabel>

              <FormControl
                name="manager"
                placeholder={
                  this.state.isManagerInputDisabled
                    ? `${i18next.t('manager_already_invited')} (${this.getManagerEmails(
                        wopi360TargetDetails
                      )})`
                    : i18next.t('invite_manager')
                }
                componentClass="input"
                onChange={this.handleChange}
                value={this.state.manager}
                disabled={this.state.isManagerInputDisabled}
                rows="8"
                style={{ maxWidth: '100%' }}
              />
            </FormGroup>
            <FormGroup
              controlId="recipients"
              validationState={this.state.form.invalidEmails.length > 0 ? 'error' : null}
            >
              <FormControl
                name="recipients"
                placeholder={i18next.t('recipients_description')}
                componentClass="textarea"
                onChange={this.handleChange}
                value={this.state.recipients}
                disabled={wopi360TargetDetails.closedAt}
                rows="8"
                style={{ maxWidth: '100%' }}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup controlId="message">
              <ControlLabel>{i18next.t('invitation_message')}</ControlLabel>

              <FormControl
                name="message"
                componentClass="textarea"
                onChange={this.handleChange}
                value={this.state.message}
                disabled={wopi360TargetDetails.closedAt}
                rows="10"
                style={{ maxWidth: '100%' }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup controlId="emailDisclaimer" style={{ paddingTop: '20px' }}>
              <input
                type="checkbox"
                name="emailDisclaimer"
                onChange={this.onChangeToggleChecked.bind(this)}
                defaultChecked={this.state.emailDisclaimer}
              />
              <span style={{ paddingLeft: '10px' }}>
                {i18next.t('email_disclaimer_checkbox_label')}
              </span>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Button
              text={i18next.t('send_invitations')}
              onClick={this.handleSendInvitations}
              disabled={!this.state.form.isValid || wopi360TargetDetails.closedAt}
            />
          </Col>
        </Row>
      </div>
    )
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  onChangeToggleChecked(e) {
    this.setState({ [e.target.name]: e.target.checked }, this.validateState)
  }

  validateState() {
    const validate = () => {
      const invalidManagerEmail = this.getInvalidManagerEmail(this.state.manager)
      const invalidRecipientEmails = this.getInvalidEmails(this.state.recipients)

      let invalidEmails = invalidRecipientEmails
      if (invalidManagerEmail.length !== 0) {
        invalidEmails = invalidRecipientEmails.concat(invalidManagerEmail)
      }

      return {
        isValid:
          (this.state.recipients.trim() !== '' || this.state.manager.trim()) &&
          invalidEmails.length === 0 &&
          this.state.emailDisclaimer,
        invalidEmails
      }
    }

    this.setState({ form: validate() })
  }

  handleSendInvitations = () => {
    const { onSendInvitations } = this.props

    onSendInvitations(
      this.state.language,
      this.transformRecipientStringToArray(this.state.recipients),
      this.state.message,
      this.state.manager
    )

    this.setState({
      recipients: '',
      manager: ''
    })
  }

  // TODO: extract
  getInvalidEmails(string) {
    const recipients = this.transformRecipientStringToArray(string)

    return recipients.filter(email => !validator.isEmail(email))
  }

  getInvalidManagerEmail(email) {
    return validator.isEmail(email) ? '' : email
  }

  checkDisableManagerInput({ wopi360TargetDetails, deletedInvitations }) {
    const managers = this.getManagerRecipients(wopi360TargetDetails)

    if (wopi360TargetDetails.closedAt) {
      return true
    } else if (managers.length > 0) {
      return this.getInvitedManagers(managers, deletedInvitations).length > 0
    }

    return false
  }

  getInvitedManagers(managers, deletedInvitations) {
    if (deletedInvitations.size > 0) {
      // Keep managers that are NOT included on deleted invitations
      return managers.filter(({ uuid }) => !deletedInvitations.contains(uuid))
    } else {
      return managers
    }
  }

  getManagerRecipients({ recipients }) {
    return recipients.filter(({ role }) => role === 'manager')
  }

  getManagerEmails({ recipients }) {
    return this.getManagerRecipients({ recipients })
      .map(manager => manager.email)
      .join(', ')
  }

  transformRecipientStringToArray(recipients) {
    return recipients
      .split(/\,|\n|\s/g)
      .map(email => email.toLowerCase().trim())
      .filter(email => email != '')
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360InvitationForm.js